@if (isIE) {
  <div id="generalError">
    <div class="generalError">
      <div class="generalError-400"></div>
      <h2>Une erreur est survenue</h2>
      <div>
        <p>Ce site web ne supporte pas ce navigateur (Internet Explorer). Vous pouvez utiliser Chrome, Edge ou un autre navigateur.</p>
      </div>
      <div class="generalError-400"></div>
      <h2>An Error Occured</h2>
      <div>
        <p>This web site do not support this browser (Internet Explorer). You can use Chrome, Edge or any other browser.</p>
      </div>
    </div>
  </div>
} @else {
  <div id="generalError">
    <div class="generalError">
      <div class="generalError-400"></div>
      <h2>{{ 'error.generalError.title' | translate }}</h2>
      @if (routeParams?.error) {
        <div>
          <p>{{ routeParams?.error }}</p>
        </div>
      }
      @if (!routeParams?.error) {
        <div>
          <p>{{ 'error.generalError.message' | translate }}</p>
        </div>
      }
      <a href="/">{{ 'error.generalError.backToHome' | translate }}</a>
    </div>
  </div>
}


